(() => {
  const modal = document.getElementById('nova-drop-modal');
  if (!modal || modal.dataset.initialized === 'true') return;
  modal.dataset.initialized = 'true';
  modal.setAttribute('aria-hidden', 'true');

  const content = modal.querySelector('.nova-modal__content');
  let form = modal.querySelector('form');
  if (!content || !form) return;
  const title = modal.querySelector('[data-nova-drop-title]');
  const subtitle = modal.querySelector('[data-nova-drop-subtitle]');
  let productName, tags, note, postcode, returnTo, submit, error;
  function bindFields() {
    productName = form.querySelector('[data-nova-drop-product-name]');
    tags = form.querySelector('[data-nova-drop-tags]');
    note = form.querySelector('[data-nova-drop-note]');
    postcode = form.querySelector('[data-nova-drop-postcode]');
    returnTo = form.querySelector('[data-nova-drop-return]');
    submit = form.querySelector('[data-nova-drop-submit]');
    error = form.querySelector('[data-nova-drop-error]');
    postcode?.addEventListener('input', buildNote);
  }
  bindFields();
  const success = modal.querySelector('[data-nova-drop-done]');
  const serverStatus = targetForm => targetForm?.querySelector('[data-nova-server-status]');
  const key = 'nova-drop-pending';
  let current = { mode: 'drop', product: '', sectionId: '' };
  let lastFocused = null;
  let currentTrigger = null;
  let submitting = false;
  let nativeMode = false;
  let activeOperation = null;
  let generation = 0;
  let lastNativeToken = '';
  // Each native operation owns one form instance; abandoned provider closures
  // keep the disconnected old instance and can never submit the replacement.
  const nativeSubmit = HTMLFormElement.prototype.submit;
  let inertElements = [];

  const isOpen = () => modal.getAttribute('aria-hidden') === 'false';
  const label = () => current.mode === 'notify' ? 'NOTIFY ME' : 'JOIN THE LIST';
  const focusable = () => Array.from(content.querySelectorAll(
    'a[href], button, input:not([type="hidden"]), select, textarea, [tabindex]'
  )).filter(element => !element.disabled && element.tabIndex >= 0 &&
    element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');

  function selectedVariant() {
    let info = current.sectionId
      ? document.querySelector(`product-info[data-section="${CSS.escape(current.sectionId)}"]`)
      : document.querySelector('product-info');
    const data = info?.querySelector('variant-selects [data-selected-variant]');
    const id = info?.querySelector('product-form form input[name="id"]')?.value;
    try {
      const variant = data ? JSON.parse(data.textContent) : null;
      // Product owns the hidden id. Never substitute a stale JSON variant or unlock its controls.
      if (id && String(variant?.id) !== String(id)) return { id, title: '' };
      return variant || (id ? { id, title: '' } : null);
    } catch { return id ? { id, title: '' } : null; }
  }

  function buildNote() {
    const parts = [];
    if (postcode?.value.trim()) parts.push(`Postcode: ${postcode.value.trim()}`);
    if (current.product) parts.push(`Product: ${current.product}`);
    const variant = current.restoredVariant || selectedVariant();
    if (variant?.title && variant.title !== 'Default Title') parts.push(`Variant: ${variant.title}`);
    if (note) note.value = parts.join(' | ');
  }

  function setContext(context) {
    current = {
      mode: context.mode === 'notify' ? 'notify' : 'drop',
      product: context.product || '',
      sectionId: context.sectionId || '',
      restoredVariant: context.variantId ? { id: context.variantId, title: context.variantTitle || '' } : null
    };
    if (title) title.textContent = modal.dataset[current.mode === 'notify' ? 'titleNotify' : 'titleDrop'] || '';
    if (subtitle) subtitle.textContent = modal.dataset[current.mode === 'notify' ? 'subNotify' : 'subDrop'] || '';
    if (productName) {
      productName.textContent = current.product;
      productName.hidden = !current.product;
    }
    if (tags) tags.value = current.mode === 'notify' ? 'restock-alert' : 'next-drop';
    if (submit) submit.textContent = submitting ? 'SENDING...' : label();
    buildNote();
  }

  function resetFeedback() {
    form.hidden = false;
    submitting = !!activeOperation;
    if (submitting) form.setAttribute('aria-busy', 'true');
    else form.removeAttribute('aria-busy');
    if (submit) { submit.disabled = submitting; submit.textContent = submitting ? 'SENDING...' : label(); }
    if (success) { success.hidden = true; success.textContent = ''; }
    if (error) { error.hidden = true; error.textContent = ''; }
    const email = form.querySelector('[type="email"]');
    email?.removeAttribute('aria-invalid');
    email?.removeAttribute('aria-describedby');
  }

  function blockBackground() {
    inertElements = Array.from(document.body.children)
      .filter(element => element !== modal && !element.contains(modal) &&
        !['SCRIPT', 'STYLE', 'LINK'].includes(element.tagName))
      .map(element => [element, element.inert]);
    inertElements.forEach(([element]) => { element.inert = true; });
  }

  function open({ focus = true } = {}) {
    if (!isOpen()) {
      lastFocused = document.activeElement;
      blockBackground();
    }
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nova-modal-open');
    document.dispatchEvent(new CustomEvent('nova:modal-state', { detail: { open: true } }));
    if (focus) (form.querySelector('input[type="email"]') || focusable()[0])?.focus();
  }

  const cleanForm = form.cloneNode(true);
  cleanForm.querySelectorAll('.h-captcha, [name="h-captcha-response"], [name="g-recaptcha-response"], [name="recaptcha-v3-token"], [name="cf-turnstile-response"], [name="form_key"]').forEach(element => element.remove());
  ['data-hcaptcha-bound', 'data-recaptcha-bound', 'data-cptcha'].forEach(name => cleanForm.removeAttribute(name));

  function guardNativeForm(target) {
    // Shopify's provider captures form.submit before binding its own wrapper.
    // Keep that captured terminal method tied to this exact, live operation.
    target.submit = function () {
      if (target !== form || !target.isConnected || activeOperation?.kind !== 'native' ||
          activeOperation.form !== target || generation !== activeOperation.generation) return;
      nativeSubmit.call(target);
    };
    target.addEventListener('submit', onSubmit);
  }

  function replaceNativeForm() {
    const emailValue = form.querySelector('input[type="email"]')?.value || '';
    const postcodeValue = postcode?.value || '';
    const replacement = cleanForm.cloneNode(true);
    // Clear the old instance before binding/focusing the replacement. Old provider
    // promises may still settle, but their captured submit method will refuse it.
    form.replaceWith(replacement);
    form = replacement;
    bindFields();
    const email = form.querySelector('input[type="email"]');
    if (email) email.value = emailValue;
    if (postcode) postcode.value = postcodeValue;
    guardNativeForm(form);
  }

  function abandonNative() {
    if (activeOperation?.kind !== 'native') return;
    const abandoned = activeOperation;
    try {
      if (pendingSubmission()?.requestId === abandoned.requestId) sessionStorage.removeItem(key);
    } catch {}
    activeOperation = null;
    lastNativeToken = '';
    replaceNativeForm();
    resetFeedback();
  }

  function close() {
    generation += 1;
    abandonNative();
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    inertElements.forEach(([element, wasInert]) => { element.inert = wasInert; });
    inertElements = [];
    if (!document.querySelector('.nova-modal.is-open')) document.body.classList.remove('nova-modal-open');
    document.dispatchEvent(new CustomEvent('nova:modal-state', { detail: { open: false } }));
    if (lastFocused?.isConnected && !lastFocused.disabled) lastFocused.focus();
  }

  function showError(message) {
    submitting = false;
    form.hidden = false;
    form.removeAttribute('aria-busy');
    if (submit) { submit.disabled = false; submit.textContent = label(); }
    if (success) success.hidden = true;
    if (error) {
      error.textContent = message; error.hidden = false;
      const email = form.querySelector('[type="email"]');
      email?.setAttribute('aria-invalid', 'true');
      email?.setAttribute('aria-describedby', error.id);
    }
  }

  function showSuccess(context = current, requestId = null) {
    submitting = false;
    form.hidden = true;
    form.removeAttribute('aria-busy');
    if (success) {
      success.textContent = context.mode === 'notify'
        ? "Your availability signup was confirmed. Email delivery is not confirmed."
        : "Your early access signup was confirmed. Email delivery is not confirmed.";
      success.hidden = false;
      if (isOpen()) success.focus();
    }
    try {
      const pending = pendingSubmission();
      if (pending && (!requestId || pending.requestId === requestId)) sessionStorage.removeItem(key);
    } catch {}
  }

  function savePending(requestId) {
    const variant = selectedVariant();
    try {
      sessionStorage.setItem(key, JSON.stringify({
        mode: current.mode, product: current.product, sectionId: current.sectionId,
        formId: form.id, variantId: variant?.id || null, variantTitle: variant?.title || '',
        postcode: postcode?.value || '', email: form.querySelector('[type="email"]')?.value || '', requestId, createdAt: Date.now()
      }));
    } catch {}
    if (returnTo) {
      const url = new URL(location.href);
      url.searchParams.delete('customer_posted');
      url.searchParams.delete('footer_newsletter');
      url.searchParams.set('nova_signup', 'product');
      returnTo.value = `${url.pathname}${url.search}#${form.id}`;
    }
  }

  function pendingSubmission() {
    try {
      const value = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (value?.formId === form.id && Number.isFinite(value.createdAt) &&
          Date.now() >= value.createdAt && Date.now() - value.createdAt < 30 * 60 * 1000) return value;
    } catch {}
    return null;
  }

  function cleanReturnUrl() {
    const url = new URL(location.href);
    url.searchParams.delete('customer_posted');
    url.searchParams.delete('nova_signup');
    if (url.hash === `#${form.id}`) url.hash = '';
    history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  }

  function submitNatively() {
    nativeMode = true;
    activeOperation = null;
    submitting = false;
    if (submit) { submit.disabled = false; submit.textContent = label(); }
    form.requestSubmit();
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest?.('[data-nova-drop-trigger]');
    if (trigger) {
      event.preventDefault();
      if (trigger.disabled || trigger.getAttribute('aria-disabled') === 'true') return;
      // Close an existing discount dialog before opening the product dialog.
      document.querySelector('#nova-discount-modal.is-open [data-nova-modal-close]')?.click();
      generation += 1;
      abandonNative();
      currentTrigger = trigger;
      resetFeedback();
      setContext({
        mode: trigger.dataset.novaDropMode,
        product: trigger.dataset.novaDropProduct,
        sectionId: trigger.dataset.novaDropSection || trigger.closest('product-info')?.dataset.section
      });
      open();
      return;
    }
    if (event.target.closest?.('[data-nova-drop-close]')) close();
  });

  document.addEventListener('keydown', event => {
    if (!isOpen()) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const elements = focusable();
    if (!elements.length) { event.preventDefault(); content.focus(); return; }
    const first = elements[0], last = elements[elements.length - 1];
    const active = document.activeElement;
    if (event.shiftKey && (active === first || !elements.includes(active))) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && (active === last || !elements.includes(active))) {
      event.preventDefault(); first.focus();
    }
  });
  document.addEventListener('change', () => { if (isOpen()) { current.restoredVariant = null; buildNote(); } });

  async function onSubmit(event) {
    if (event.currentTarget !== form || !form.isConnected) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    const native = !!document.getElementById('captcha-bootstrap') || nativeMode;
    const token = Array.from(form.querySelectorAll('[name="h-captcha-response"], [name="g-recaptcha-response"], [name="recaptcha-v3-token"], [name="cf-turnstile-response"]'))
      .map(field => field.value).filter(Boolean).join('|');
    // Block duplicate user submits, but allow Shopify's token-bearing or synthetic CAPTCHA continuation.
    const captchaResume = native && activeOperation?.kind === 'native' &&
      activeOperation.form === form && submitting &&
      ((token && token !== lastNativeToken) || (!event.isTrusted && !event.submitter));
    if (submitting && !captchaResume) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    if (!form.reportValidity()) { event.preventDefault(); return; }
    if (captchaResume) { lastNativeToken = token; return; }
    if (current.mode === 'notify' && currentTrigger?.isConnected &&
        (currentTrigger.disabled || currentTrigger.getAttribute('aria-disabled') === 'true')) {
      event.preventDefault();
      showError('Please choose an available product option before signing up.');
      return;
    }
    // A recovered native flow uses a new, token-free form instance.
    current.restoredVariant = null;
    buildNote();
    const operation = { requestId: crypto.randomUUID(), context: { ...current }, generation, form, kind: native ? 'native' : 'ajax' };
    activeOperation = operation;
    savePending(operation.requestId);
    submitting = true;
    form.setAttribute('aria-busy', 'true');
    if (submit) { submit.disabled = true; submit.textContent = 'SENDING...'; }
    if (error) error.hidden = true;
    if (native) { lastNativeToken = token; return; }
    event.preventDefault();
    const ownsUI = () => activeOperation === operation && generation === operation.generation;
    try {
      const response = await fetch(form.action, { method: 'POST', body: new FormData(form) });
      const html = await response.text();
      if (!ownsUI()) return;
      const url = new URL(response.url || form.action, location.href);
      const challenge = /\/(challenge|checkpoint)(\/|$)/.test(url.pathname) ||
        (!response.ok && /captcha|form_key/i.test(html));
      if (challenge) { submitNatively(); return; }
      const documentResult = new DOMParser().parseFromString(html, 'text/html');
      const resultForm = documentResult.getElementById(form.id);
      if (response.ok && serverStatus(resultForm)?.dataset.novaServerSuccess === 'true' &&
          serverStatus(resultForm)?.dataset.novaServerErrors !== 'true') {
        showSuccess(operation.context, operation.requestId);
        return;
      }
      const returnedError = resultForm?.querySelector('[data-nova-drop-error]');
      showError(returnedError && returnedError.textContent.trim()
        ? returnedError.textContent.trim()
        : "We couldn't confirm your signup. Please try again.");
    } catch {
      if (ownsUI()) showError("We couldn't connect. Your details are still here; please try again.");
    } finally {
      if (activeOperation === operation) {
        activeOperation = null;
        submitting = false;
        form.removeAttribute('aria-busy');
        if (submit) { submit.disabled = false; submit.textContent = label(); }
      }
    }
  }
  // A deferred script can arrive after bootstrap has already begun protection.
  // Never overwrite a provider's live submit wrapper: start with a clean instance
  // so the provider captures our guarded terminal method on its next binding.
  if (form.hasAttribute('data-hcaptcha-bound') || form.hasAttribute('data-recaptcha-bound') ||
      form.hasAttribute('data-cptcha')) replaceNativeForm();
  else guardNativeForm(form);

  const pending = pendingSubmission();
  const url = new URL(location.href);
  const ownReturn = url.hash === `#${form.id}` &&
    (!url.searchParams.has('nova_signup') || url.searchParams.get('nova_signup') === 'product') &&
    !url.searchParams.has('footer_newsletter');
  if (pending && ownReturn) {
    if (postcode) postcode.value = pending.postcode || '';
    const email = form.querySelector('[type="email"]');
    if (email && !email.value && typeof pending.email === 'string') email.value = pending.email;
    setContext(pending);
    if (serverStatus(form)?.dataset.novaServerSuccess === 'true' && serverStatus(form)?.dataset.novaServerErrors !== 'true') {
      open({ focus: false });
      showSuccess();
      cleanReturnUrl();
    } else if (serverStatus(form)?.dataset.novaServerErrors === 'true') {
      const message = error?.textContent.trim() || 'Please check your email and try again.';
      open();
      showError(message);
      cleanReturnUrl();
    } else {
      open();
      showError("We couldn't confirm your signup. Please try again.");
      cleanReturnUrl();
    }
  }
})();
